module.exports = __webpack_public_path__ + "r-v3/img/eraser_gray.c0518e95.svg";